<div name="customerGridContainer">
     <div class="overlay"
          *ngIf="isLoading">
          <h1 class="heading"
              [innerHtml]="'Loading' | translator: 'base'"
              [title]="'Loading' | translator: 'base'">Loading...</h1>
          <img [alt]="'Loading' | translator: 'base'" />
     </div>


     <ag-grid-angular (gridReady)="onGridReady($event)"
                      (gridSizeChanged)="smartSizeColumns()"
                      style="width: 100%;"
                      class="ag-theme-alpine"
                      [columnDefs]="columnDefs"
                      [defaultColDef]="defaultColDef"
                      [rowData]="rowData$"
                      [gridOptions]="gridOptions"
                      [overlayLoadingTemplate]="overlayLoadingTemplate"
                      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                      [domLayout]='domLayout'
                      (model-updated)="cleanModel()"
                      rowModelType="clientSide"
                      
     ></ag-grid-angular>

     <div class="psuedo-hidden"
          #pageVooDoo
          [innerHtml]="translate('Voodoo')">Voodoo||| DO NOT CHANGE TO display:none or translation won't be triggered
          and grid language will not change on language drop down change.</div>

</div>